import { ErrorCode, ResponceDataType } from "../../../../ErrorCode";
/**
 * 学習設定１（乗数設定）
 */
export type STUDY_SET_1 = {

  //演算項目
  CLC_TYPE: string;
  ///演算項目名称
  CLC_TYPE_NAME: string;
  /// 速度
  SPD: number;
  /// 演算種別コード
  TYP_NO?: number;
//演算種別名
  TYP_NAME: string;
  /// 軽故障乗数
  WRN_NUM?: number;
  /// 重故障乗数
  ALM_NUM?: number;

  /// 連番
  indexNo: number;
  /// 編集フラグ
  isEdit: boolean;

};

/**
 * 学習設定２（乗数設定）
 */
export type STUDY_SET_2 = {

  //項目名称No
  ITM_NAME_NO?: number;
  //項目名称
  ITM_NAME: string;
  ///演算項目名称
  THR_NUM?: number;

  /// 連番
  indexNo: number;
  /// 編集フラグ
  isEdit: boolean;

};

/**
 * 学習設定モデル
 */
export type StudySettingModel = {
  StudySet1List:STUDY_SET_1[],
  StudySet2List: STUDY_SET_2[],
  ResponceDataModel?:ResponceDataType
}


/**
 *　デフォルトデータ作成
 * @returns
 */
export const CreateStudySettingModel = () : StudySettingModel => {
  let ret: StudySettingModel = {
    StudySet1List: [],
    StudySet2List: []
  };
  return ret;
}

//学習設定データ取得
export const GetStudySetting = (): Promise<StudySettingModel> => {
  return new Promise((resolve, reject) => {
    fetch("api/StudySetting/")
      .then((res) => {
        if (!res.ok) {
           console.error(res);
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: StudySettingModel) => {
        console.debug(["GetStudySetting - ok ret ", result]);
        if (result != null ) {
          if (result.StudySet1List.length !== 0) {
            result.StudySet1List.map((row, index) => {
              //連番付与
              row.indexNo = index + 1;
              row.isEdit = false;
            });
          }
          if (result.StudySet2List.length !== 0) {
            result.StudySet2List.map((row, index) => {
              //連番付与
              row.indexNo = index + 1;
              row.isEdit = false;
            });
          }
          console.debug(["GetStudySetting - ok ret ", result]);
          resolve(result);
        }
        else {
          reject('Invalidate response');
        }
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      })
  })
};

/**
 *学習設定データ更新
 * @returns
 */
export const PutStudySetting = (settings : StudySettingModel): Promise<ResponceDataType> => {
  return new Promise((resolve, reject) => {
    settings.StudySet1List = settings.StudySet1List.filter((r) => r.isEdit == true);
    settings.StudySet2List = settings.StudySet2List.filter((r) => r.isEdit == true);
    console.debug(["PutStudySetting - updateSetting",settings]);
    fetch("api/StudySetting/", {
      method: "put",
      headers: {
            'Content-Type': 'application/json'
      },
      body: JSON.stringify(settings)
    }).then((res) => {
      if (!res.ok) {
        let message = `データが見つかりませんでした status:${res.status}`;
        reject(message);
      }
      return res.json();
    }).then((result: ResponceDataType) => {
      console.debug(["PutStudySetting - result ",result])
      resolve(result);
    },
      (error) => {
        console.error(error);
        reject(error);
      })
  });
}


/**
 * 編集チェック
 */
export const CheckStudySettingEditFlg = (targetModel: StudySettingModel): boolean => {

  if (targetModel.StudySet1List == null || targetModel.StudySet1List.length == 0) {
    return false;
  }

  if ((targetModel.StudySet1List.findIndex((r) => r.isEdit == true) == -1) &&
    (targetModel.StudySet2List.findIndex((r) => r.isEdit == true) == -1)) {
    return false;
  }

  return true;
};

/**
 * 画面で入力された値のチェック
 * @param targetList チェック対象の配列
 * @param translation 多言語化のオブジェクト
 * @returns エラーがあれば文字列で返す、なければ空
 */
export const CheckStudySettingInputData = (targetList: STUDY_SET_1[], translation: any) :string[] =>{
  let errorMsgs :string[] = [];

  targetList.forEach((r,index) =>{
      if(r.WRN_NUM != null && r.ALM_NUM != null){
        if (r.WRN_NUM > r.ALM_NUM) {
          errorMsgs.push(`No.${index+1} `+
            translation(
                  'StudySettingPage.登録データが不正です_警報閾値(軽故障乗数>重故障乗数)',
                  '登録データが不正です。警報閾値(軽故障乗数>重故障乗数)'
            )
          );
        }
      }
  });
  return errorMsgs;
};
